// extracted by mini-css-extract-plugin
module.exports = {"container":"Utilities_UnsaveIcon_container","topTooltip":"Utilities_UnsaveIcon_topTooltip","leftTooltip":"Utilities_UnsaveIcon_leftTooltip","icon":"Utilities_UnsaveIcon_icon"};